export default __webpack_public_path__ + "assets/images/logo4.0f3d2f5d.png";